<template>
  <section class="products-section">
    <div class="products-section-container">
      <div class="products-section-title">
        <h4>{{ title }}</h4>
        <p>{{ subtitle }}</p>
      </div>
      <div class="products">
        <div class="product-collections" v-if="showProductCollections">
          <a v-for="category in categories" :key="category" class="product-collections-item" href="#">{{ category }}</a>
        </div>
        <div class="product-items">
          <ProductItem v-for="product in displayedProducts" :key="product.id" :product="product" @click="goToProduct(product.id)" :saleType="saleType" />
        </div>
        <a v-if="showLoadMoreBtn" href="#" class="load-more-btn">查看更多</a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ProductItem from './ProductItem.vue'

export default {
  name: 'ProductsSection',
  components: {
    ProductItem
  },
  props: {
    saleType: {
      type: String,
      default: 'retail'
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    productType: {
      type: String,
      default: 'all'
    },
    showLoadMoreBtn: {
      type: Boolean,
      default: true
    },
    showProductCollections: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(['categories', 'products']),
    ...mapGetters(['getNewArrivals', 'getSaleProducts']),
    displayedProducts() {
      if (this.productType === 'new') {
        return this.getNewArrivals.slice(0, 9)
      } else if (this.productType === 'all') {
        return this.products;
      } else if (this.productType === 'sale') {
        return this.getSaleProducts.slice(0, 9)
      } else {
        return this.products.slice(0, 9)
      }
    }
  },
  methods: {
    goToProduct(id) {
      this.$router.push(`/product/${id}?saleType=${this.saleType}`)
    }
  }
}
</script> 